
import React from 'react';
import { DiagnosticResult } from './types';
import { AuthStatusSection } from './AuthStatusSection';
import { UserRolesSection } from './UserRolesSection';
import { RLSPoliciesSection } from './RLSPoliciesSection';
import { ConnectionsDataSection } from './ConnectionsDataSection';
import { SampleConnectionsSection } from './SampleConnectionsSection';
import { AssignedBasesSection } from './AssignedBasesSection';

interface DiagnosticsContentProps {
  results: DiagnosticResult | null;
}

export const DiagnosticsContent: React.FC<DiagnosticsContentProps> = ({ results }) => {
  if (!results) return null;

  return (
    <div className="space-y-4">
      <AuthStatusSection results={results} />
      <UserRolesSection results={results} />
      <RLSPoliciesSection results={results} />
      <ConnectionsDataSection results={results} />
      <SampleConnectionsSection results={results} />
      <AssignedBasesSection results={results} />
    </div>
  );
};
